// extracted by css-extract-rspack-plugin
export default {"base":"VqWcsg0FLyokMuaB","small":"_rm58iPSs34wg1KO","medium":"fykM0dNwaeskZLLF"};